import { MatDialog as MatDialog } from '@angular/material/dialog';
import { Component, OnInit } from '@angular/core';

import { ApiDialogService } from 'src/app/services/api/api-cdialog.service';
import { ApiStoreService } from './../../../services/api/api-store.service';
import { IStoreConfig, IStoreParameters } from '../../../models/storeConfig';
import { StoreConfigHeaderItems } from 'src/app/shared/utils/base';
import { DialogEmailTypeEnum } from 'src/app/models/email';
import { ModalLojaComponent } from './modal-loja/modal-loja.component';
import { DialogTypeEnum, IDialogConfirm } from 'src/app/models/dialog';
import { IPagination } from 'src/app/models/generic';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { IFieldOrder } from 'src/app/models/manual-batch';

@Component({
  selector: 'app-configuracoes-loja',
  templateUrl: './configuracoes-loja.component.html',
  styleUrls: ['./configuracoes-loja.component.scss']
})
export class ConfiguracoesLojaComponent implements OnInit {
  storeConfigHeader = StoreConfigHeaderItems;
  DialogEmailTypeEnum = DialogEmailTypeEnum;

  fieldsOrders: IFieldOrder[] = [];
  storeConfigs: IStoreConfig[] = [];
  storeParameters!: IStoreParameters;

  pagination: IPagination = { Skip: 0, Take: 10 };
  count: number = 0;

  constructor(
    private _dialog: MatDialog,
    private _storeConfigService: ApiStoreService,
    private _dialogService: ApiDialogService,
    private _snackbarService: SnackbarService
  ) {}

  ngOnInit(): void {
    this.getAllStoreConfig();
    this.getStoreParameters();
  }

  getAllStoreConfig(): void {
    this._storeConfigService.getAllStoreConfig(this.pagination).subscribe({
      next: (response) => {
        this.storeConfigs = [...response.Data];
        this.count = response.Count;
      }
    });
  }

  getAllStoreSettingsSorted(): void {
    this._storeConfigService.getAllStoreSettingsSorted(this.pagination, this.fieldsOrders).subscribe({
      next: (response) => {
        this.storeConfigs = [...response.Data];
        this.count = response.Count;
      }
    });
  }

  getStoreParameters(): void {
    this._storeConfigService.getParametersStoreConfig().subscribe({
      next: (response) => {
        this.storeParameters = { ...response };
      }
    });
  }

  orderChange(fieldsOrder: IFieldOrder[]): void {

    this.fieldsOrders = [...fieldsOrder];

    this.getAllStoreSettingsSorted();
  }

  openStoreDialog(storeConfig?: IStoreConfig): void {
    const dialogRef = this._dialog.open(ModalLojaComponent, {
      data: { storeConfig, parameters: this.storeParameters },
      panelClass: 'max-vh-95'
    });

    dialogRef.afterClosed().subscribe({
      next: (response) => {
        if (response) {
          this.getAllStoreConfig();
        }
      }
    });
  }

  handleOpenDialogEdit(storeConfig: IStoreConfig): void {
    this.openStoreDialog(storeConfig);
  }

  handleOpenDialogDelete(storeConfig: IStoreConfig): void {
    const dialogData: IDialogConfirm = {
      type: DialogTypeEnum.Optional,
      appearance: 'modern',
      template: {
        boldTitle: 'Excluir configuração',
        title: 'Tem certeza que deseja excluir essa configuração?',
        confirm: 'Sim',
        dismiss: 'Não'
      }
    };

    this._dialogService.openDialog(dialogData).then((response) => {
      if (response) this.deleteStoreConfig(storeConfig);
    });
  }

  deleteStoreConfig(storeConfig: IStoreConfig): void {
    this._storeConfigService
      .deleteStoreConfig(storeConfig.StoreConfigId!)
      .subscribe({
        next: (response) => {
          this._snackbarService.openSnackBar(
            'Configuração excluida com sucesso!',
            'success'
          );
          this.getAllStoreConfig();
        }
      });
  }

  handlePagination(pagination: IPagination): void {
    this.pagination = { ...pagination };
    this.getAllStoreConfig();
  }
}
